module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/project/middlePlatform/components/QualificationItemList/asset/grabGrayImg.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/project/middlePlatform/components/QualificationItemList/asset/grabGrayImg.png
// module id = 793
// module chunks = 438